import React, { memo } from 'react'

// Skeleton loading
import Skeleton from 'react-loading-skeleton';

function CustomerMarketingEmails__loadingSkeleton() {
    return (
        <React.Fragment>
            <div className="d-flex">
                <div>
                    <Skeleton count={1} height={20} width={200} className="mb-3" /> <br />
                    <Skeleton count={1} height={50} width={400} />
                </div>
                <div className="ms-auto">
                    <Skeleton count={1} height={35} width={100} />
                </div>
            </div>
        </React.Fragment>
    )
}

export default memo(CustomerMarketingEmails__loadingSkeleton)